import { APIClient } from './client';
import { api } from '../../Infrastructure/config';

import { ResultsEndpoint } from '../../store/api/ResultsEndpoint';
// // Create the APIClient from config
import { FiltersEndpoint } from "../../store/api/FiltersEndpoint";
import { ShortlistEndpoint } from "../../store/api/ShortlistEndpoint";

const apiClient = new APIClient(api.url, api.appSecret, api.isDebugEnabled);

apiClient.register(new FiltersEndpoint());
apiClient.register(new ResultsEndpoint());
apiClient.register(new ShortlistEndpoint());


export default apiClient;
